import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7;
  var pagename = 'lamodau-baonhieulan';
  var pn = "div[data-name=\"".concat(pagename, "\"]");
  var id_emp = 0;
  var month = moment().subtract(1, 'months').format('YYYY-MM'); //Đăng ký sự kiện chọn nhân viên

  Base.app.off('lamodauEvent');
  Base.app.on('lamodauEvent', function (data) {
    id_emp = data.id;
    var emp = Base.initdata.employees.find(function (e) {
      return e.id === data.id;
    });
    $(pn + ' .emp-name').text(emp.name);
  });
  var rows = [];

  var getdata = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              month = $(pn + ' input[name="month"]').val();

              if (!(month.length != 7 || month.indexOf('-') === -1)) {
                _context.next = 4;
                break;
              }

              $f7.dialog.alert('Thời gian sai định dạng');
              return _context.abrupt("return", false);

            case 4:
              _context.next = 6;
              return Base.api('WorkingCalendar', 'lamodau_baonhieulan', {
                id_emp: id_emp,
                month: month
              });

            case 6:
              rs = _context.sent;

              if (!(rs.rows.length === 0)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              rows = rs.rows;
              $update();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getdata() {
      return _ref2.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${pagename}">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Làm ở đâu, bao nhiêu lần</div>
      <div class="right"></div>
    </div>
  </div>
  <div class="page-content">
    <div class="list no-margin">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <a class="button selected-actor" href="/employee-list-popup/lamodauEvent">Chọn nhân viên</a>
          </div>
          <div class="item-inner emp-name">
            -
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-label">Tháng</div>
            <div class="item-input-wrap">
              <input type="text" name="month" value="${month}" placeholder="YYYY-MM (VD: 2022-04)"/>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="block text-align-center" style="margin: 10px 0px;">
      <a class="button" @click=${getdata}>Xem</a>
    </div>
    <div class="data-table review-emp-table no-margin">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Cơ sở</th>
            <th class="numeric-cell">Số buổi</th>
          </tr>
        </thead>
        <tbody>
          ${rows.map(row=>$h`
            <tr>
              <td class="label-cell">${row.branch_name}</td>
              <td class="numeric-cell">${row.working_times}</td>
            </tr>
          `)}
        </tbody>
      </table>
    </div>
  </div>
</div>
`
    }
    ;
});